export default [
  {
    text: "Home",
    path: "/home",
    icon: "home"
  },
  {
    text: "Contact Info",
    path: "/contact-info",
    icon: "card"
  },
  {
    text: "Admin",
    path: "/admin-main",
    icon: "user",
  },
  /*{
    text: "Examples",
    icon: "folder",
    items: [
      {
        text: "Profile",
        path: "/profile"
      },
      {
        text: "Display Data",
        path: "/display-data"
      }
    ]
  }*/
  ];
